import { render, staticRenderFns } from "./user-progess.vue?vue&type=template&id=96ca5d26&scoped=true&"
import script from "./user-progess.vue?vue&type=script&lang=js&"
export * from "./user-progess.vue?vue&type=script&lang=js&"
import style0 from "./user-progess.vue?vue&type=style&index=0&id=96ca5d26&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ca5d26",
  null
  
)

export default component.exports